import PostForm from "../post-form";
import { useQueryClient } from "@tanstack/react-query";

const EditPostModal = ({ isOpen, onClose, post, queryParams }) => {
  const queryClient = useQueryClient();

  if (!isOpen) return null;

  console.log(post);

  const handleUpdateSuccess = (updatedPost) => {
    // Update the cached posts data using the same pattern as delete
    if (queryParams) {
      queryClient.setQueryData(["posts", queryParams], (oldData) => {
        if (!oldData) return oldData;
        const newData = {
          ...oldData,
          data: oldData.data.map((p) =>
            p.id === updatedPost.id ? updatedPost : p
          ),
        };
        return newData;
      });
    }

    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          onClick={onClose}
        ></div>

        {/* Modal panel */}
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-7xl sm:w-full">
          <div className="relative">
            {/* Close button */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-500 z-10"
            >
              <span className="sr-only">Mbyll</span>
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Form content */}
            <div className="max-h-[90vh] overflow-y-auto">
              <PostForm
                onSuccess={handleUpdateSuccess}
                mode="edit"
                initialData={post}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPostModal;
